import { createFileRoute } from '@tanstack/react-router'

import { PortalQuestionnaire } from '@/components/portal/portal-questionnaire'

/** Espace client › un questionnaire : y répondre, relire ses réponses (lot 23). */
export const Route = createFileRoute('/portal/questionnaires/$questionnaireId')({
  component: PortalQuestionnaireRoute,
})

function PortalQuestionnaireRoute() {
  const { questionnaireId } = Route.useParams()
  return <PortalQuestionnaire id={questionnaireId} />
}
